import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import CircularProgress from '@material-ui/core/CircularProgress'
import { withStyles } from '@material-ui/core/styles'
import { compose } from 'recompose'

import Input from '../../common/Input'

import * as Strings from './strings'
import * as configActions from '../../../actions/Config'
import * as userActions from '../../../actions/User'
import * as Constants from '../../../helpers/Constants'

class DeleteAccountModal extends Component {
  state = {
    passwordInput: '',
    errorPassword: '',
    errorMessage: ''
  }

  componentWillReceiveProps(nextProps) {
    const { config, user } = this.props

    // Reset state when modal opens
    if (
      nextProps.config.showDeleteAccountModal &&
      !config.showDeleteAccountModal
    ) {
      this.setState({
        passwordInput: '',
        errorPassword: '',
        errorMessage: ''
      })
    }

    // On successful delete, redirect to login
    if (
      !nextProps.user.isDeleting &&
      nextProps.user.errorDeleting === null &&
      user.isDeleting
    ) {
      this.props.history.push('/')
    } else if (
      !nextProps.user.isDeleting &&
      nextProps.user.errorDeleting !== null &&
      user.isDeleting
    ) {
      if (nextProps.user.errorDeleting === 401) {
        this.setState({
          errorPassword: Strings.default.INCORRECT_PASSWORD[config.language]
        })
      } else {
        this.setState({
          errorMessage: Strings.default.INTERNAL_ERROR[config.language]
        })
      }
    }
  }

  confirm() {
    const { user, config } = this.props
    const { passwordInput } = this.state

    this.setState({ errorPassword: '', errorMessage: '' })

    if (passwordInput === '') {
      this.setState({
        errorPassword: Strings.default.MANDATORY_FIELD[config.language]
      })
      return
    }

    this.props.tryDeleteAccount(user.token, { password: passwordInput })
  }

  render() {
    const { config, user, classes } = this.props
    const { passwordInput, errorPassword, errorMessage } = this.state

    return (
      <Dialog
        open={config.showDeleteAccountModal}
        aria-labelledby={'delete-account-dialog-title'}
        classes={{ paperScrollPaper: classes.container }}
      >
        <DialogTitle id={'delete-account-dialog-title'}>
          {Strings.default.DELETE_ACCOUNT[config.language]}
        </DialogTitle>
        <DialogContent>
          {errorMessage === '' ? null : (
            <p style={{ fontSize: 12, color: '#e57373' }}>{errorMessage}</p>
          )}
          <Input
            placeholder={Strings.default.PASSWORD[config.language]}
            value={passwordInput}
            onChange={text =>
              this.setState({ passwordInput: text, errorPassword: '', errorMessage: '' })
            }
            error={errorPassword}
            type={'password'}
          />
        </DialogContent>
        {user.isDeleting ? (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: 15
            }}
          >
            <CircularProgress
              style={{ color: Constants.WHITE_LABEL.colors.primary }}
              thickness={6}
              size={20}
            />
          </div>
        ) : (
          <DialogActions>
            <Button
              onClick={() => this.props.hideDeleteAccountModal()}
              classes={{ label: classes.cancelButtonText }}
            >
              {Strings.default.CANCEL[config.language]}
            </Button>
            <Button
              onClick={() => this.confirm()}
              classes={{ label: classes.deleteButtonText }}
            >
              {Strings.default.CONFIRM_DELETE[config.language]}
            </Button>
          </DialogActions>
        )}
      </Dialog>
    )
  }
}

const Styles = {
  container: {
    width: '100%'
  },
  deleteButtonText: {
    color: '#e53935'
  },
  cancelButtonText: {
    color: Constants.WHITE_LABEL.colors.warning
  }
}

function mapStateToProps({ config, user }) {
  return { config, user }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...configActions, ...userActions }, dispatch)
}

export default compose(
  withStyles(Styles),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(DeleteAccountModal)



// WEBPACK FOOTER //
// ./src/components/containers/DeleteAccountModal/index.js